import React from "react";
import { Card, CardContent, Typography, Alert } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Link from "@mui/material/Link";
import * as yup from "yup";
import { Form, Formik } from "formik";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";
import Div from "@jumbo/shared/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";

import { useAPI } from "app/hooks/useApi";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { mapApiError } from "app/utils/errorMessages";

const validationSchema = yup.object({
  email: yup
    .string("Digite seu e-mail")
    .email("Digite um e-mail válido")
    .required("E-mail é obrigatório"),
  password: yup.string("Digite sua senha").required("Senha é obrigatória"),
});

const Login = () => {
  const navigate = useNavigate();
  const { makeRequest, responseData, error, loading, success } = useAPI();
  const [loginError, setLoginError] = React.useState("");
  const { setAuthToken, setAuthData } = useJumboAuth();

  const onSignIn = async (email, password) => {
    try {
      const response = await makeRequest("/auth/login", "POST", { email, password });
      if (response && response.status === 200) {
        setLoginError("");
        const data = response.data || {};
        const token = data.token || data.accessToken || data.authToken || null;

        if (token && data.user) {
          // Armazenar token no localStorage para persistência entre reloads
          localStorage.setItem('token', token);
          // Setar estado de autenticação diretamente (sem chamar /auth/status)
          setAuthData({ authToken: token, authUser: data.user, isLoading: false });
          navigate('/dashboard');
          return;
        }

        if (token) {
          await setAuthToken(token);
          navigate('/dashboard');
          return;
        }

        if (data.user) {
          setAuthData({ authToken: null, authUser: data.user, isLoading: false });
          navigate('/dashboard');
          return;
        }

        setLoginError('Resposta de login inválida.');
      } else {
        setLoginError(mapApiError(response));
      }
    } catch (err) {
      setLoginError(mapApiError(err));
    }
  };

  //temp
  const mutation = { isError: false };
  return (
    <Div
      sx={{
        flex: 1,
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: (theme) => theme.spacing(4),
        background: "#182722",
      }}
    >
      <Card sx={{ maxWidth: "100%", width: 360, mb: 4 }}>
        <CardMedia
          component="img"
          alt="Bunker - Marcas e Patentes"
          height="200"
          image={`/images/bunker-login.png`}
        />
        <CardContent sx={{ pt: 1 }}>
          <Formik
            validateOnChange={true}
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (data, { setSubmitting }) => {
              setSubmitting(true);
              await onSignIn(data.email, data.password);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting }) => (
              <Form style={{ textAlign: "left" }} noValidate autoComplete="off">
                {loginError && (
                  <Alert severity="error" sx={{ mb: 2 }}>
                    {loginError}
                  </Alert>
                )}
                <Div sx={{ mb: 3, mt: 1 }}>
                  <JumboTextField fullWidth name="email" label="Email" />
                </Div>
                <Div sx={{ mb: 2, mt: 1 }}>
                  <JumboTextField
                    fullWidth
                    name="password"
                    label="Senha"
                    type="password"
                  />
                </Div>
                <Typography textAlign={"right"} variant={"body1"} my={1}>
                  <Link underline="none" href="#">
                    Esqueceu sua senha?
                  </Link>
                </Typography>
                <LoadingButton
                  fullWidth
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{ mb: 3 }}
                  loading={loading || mutation.isLoading}
                  color="info"
                >
                  Login
                </LoadingButton>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Div>
  );
};

export default Login;
